<template>
  <div>
    <sweet-input
      :isValid="!$v.form.name.$error"
      @input="$v.form.name.$touch()"
      v-model="form.name"
      type="text"
      layout="vertical"
      :placeholder="$t('common.name')"
      :label="$t('common.person-name-surname')"
      class="mb-3"
    />
    <sweet-input
      :isValid="!$v.form.email.$error"
      @input="$v.form.email.$touch()"
      v-model="form.email"
      type="email"
      layout="vertical"
      :placeholder="$t('common.email')"
      label="Email"
      labelClass="mt-2"
      class="mb-3"
    />

    <h6 class="mt-2">{{ $t("timezone.name") }}</h6>
    <multiselect
      v-if="timezones"
      v-model="form.timezone"
      track-by="abbr"
      :placeholder="$t('timezone.select-time')"
      :options="timezones"
      :searchable="true"
      :allow-empty="false"
      :show-labels="false"
      label="text"
      @select="onSelect"
      class="mb-3"
    >
    </multiselect>

    <h6 class="mt-2">{{ $t("common.language") }}</h6>
    <multiselect
      v-model="form.language"
      track-by="language"
      :placeholder="$t('common.language-select')"
      :options="languages"
      :searchable="false"
      :allow-empty="false"
      :show-labels="false"
      @select="onSelect"
      class="mb-3"
    >
      <template slot="singleLabel" slot-scope="{ option }">
        <div class="d-flex align-items-center">
          <img :src="`${option.flag}`" alt="user-image" class="mr-1" height="12" />
          <span class="align-middle">{{ option.title[option.language] }}</span>
        </div>
      </template>
      <template slot="option" slot-scope="{ option }">
        <div class="d-flex align-items-center">
          <img :src="`${option.flag}`" alt="user-image" class="mr-1" height="12" />
          <span class="align-middle">{{ option.title[option.language] }}</span>
        </div>
      </template>
    </multiselect>

    <h6>{{ $t("role.plural") }}</h6>
    <multiselect
      v-model="form.workspaceRole"
      track-by="definition"
      :placeholder="$t('workspace.role')"
      :options="workspaceRoles"
      :searchable="false"
      :allow-empty="false"
      :show-labels="false"
      class="mt-2"
    >
      <template slot="singleLabel" slot-scope="{ option }">
        <div>
          <b> <i class="mdi mdi-account-circle"></i> {{ option.name | translate }} </b>
          <div v-html="$options.filters.translate(option.description)"></div>
        </div>
      </template>
      <template slot="option" slot-scope="{ option }">
        <b> <i class="mdi mdi-account-circle"></i> {{ option.name | translate }} </b>
        <div v-html="$options.filters.translate(option.description)"></div>
      </template>
    </multiselect>

    <div class="d-flex mt-4" style="gap: 0.75rem;">
      <button class="button cancel-button w-50 flex-shrink-1" @click="closeModal">
        {{ $t("common.cancel") }}
      </button>
      <button class="button save-button w-50 flex-shrink-1" @click="invite" :disabled="$v.form.$invalid">
        {{ $t("workspace.allow-access-to-workspace") }}
      </button>
    </div>
  </div>
</template>

<script>
import { email, maxLength, minLength, required } from "vuelidate/lib/validators";

export default {
  props: { workspace: { type: Object }, scope: { type: String, default: "ACCOUNT", required: false } },
  data() {
    return {
      form: {
        name: undefined,
        email: undefined,
        language: undefined,
        timezone: undefined,
        workspaceRole: this.$store.getters["workspaceRole/WorkspaceRoleMember"],
      },
      workspaceRoles: this.$store.getters["workspaceRole/roles"],
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(40),
      },
      workspaceRole: {
        required,
      },
      email: {
        email,
        required,
      },
      timezone: {
        required,
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters["workspace/isUpdating"];
    },
    languages() {
      return this.$store.getters["localization/languages"];
    },
    timezones() {
      return this.$store.getters["localization/timezones"];
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    async invite() {
      try {
        await this.$store.dispatch(this.scope == "MANAGEMENT" ? "managementWorkspace/invite" : "workspace/invite", {
          ...this.form,
          language: this.form.language.language,
          workspace: this.workspace,
          options: {},
        });
        this.$emit("onSent");
        this.$toast.success(this.$t("common.success"));
        this.closeModal();
      } catch (error) {
        this.$toast.warning(error.data.message);
      }
    },
    onSelect() {
      this.$forceUpdate();
    },

    init() {
      this.form.language = this.languages.find((l) => l.language == "tr");
      this.$store.dispatch("localization/fetchTimezones");
    },

    closeModal() {
      this.$emit("closeModal");
    },
  },
};
</script>
